import { WebColors } from '@sparelabs/colors'
import styled from 'styled-components'

export const LinkText = styled.a`
  color: ${WebColors.interactivePrimary};
  :hover {
    color: ${WebColors.interactivePrimaryHover};
    cursor: pointer;
  }
`
